import { PublicSales } from '../models/public-sales';
import { PublicSalesResponse } from '../api/response/public-sales.response';

export const publicSalesFromResponse = (
  response: PublicSalesResponse,
): PublicSales => {
  return new PublicSales({
    id: response.id,
    type: response.type,
    subProductId: response.subProductId,
    maxQuantityPerOrder: response.maxQuantityPerOrder,
    availability: response.availability,
  });
};
